export default {
  PAGE_LIMIT: 30,
  REQUESTS_PARAMS: {
    type: [1, 2],
  },
}
